import { EventEmitter, Injectable, ComponentFactoryResolver, ViewContainerRef } from "@angular/core";
import { WhitelabelConfig } from "../_models/whitelabelConfig.model";
import { ApiService } from ".";
import * as _ from 'lodash';
import { WhitelabelFeature } from "../_models/whitelabelFeature.model";
import { environment } from "../../environments/environment";
import {Http, Response, RequestOptionsArgs, Headers, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin';
import { map } from "lodash";

@Injectable()
export class WhitelabelService {
    private _baseUrl = "";
    whitelabelConfigs: WhitelabelConfig[];
    whitelabelConfigsButtons: WhitelabelConfig[] = [];
    whitelabelFeatures: WhitelabelFeature[];
    isLoading= true;
    loadedEvent: EventEmitter<any> = new EventEmitter();

    constructor(private http: Http) {
        this._baseUrl = environment.apiBaseUrl;
    }

    public load(){
        Observable.forkJoin([this.getWhitelabelConfigsByHostName(),this.getWhitelabelFeatures()])
        .subscribe(results => { 
            this.whitelabelConfigs = results[0];
            _.each(this.whitelabelConfigs, config=>{
                config.featureSettingsObj = JSON.parse(config.featureSettings);
            })
            this.whitelabelConfigsButtons = _.filter(this.whitelabelConfigs, c=>{
                if(c.featureSettingsObj.iconStyle){
                    c.featureSettingsObj.iconStyle = JSON.parse(c.featureSettingsObj.iconStyle)
                }
                return c.featureSettingsObj.buttonFunction;
            }) as any;
            // console.log(this.whitelabelConfigsButtons)
            this.whitelabelConfigsButtons = _.orderBy(this.whitelabelConfigsButtons,'featureSettingsObj.index')
            

            this.whitelabelFeatures = results[1];
            this.isLoading = false;
            this.loadedEvent.emit();
        });
    }


    private getWhitelabelConfigsByHostName(): Observable<any>{
        return this.http.get(environment.apiBaseUrl +'/api/whitelabelConfig/' + window.location.host)
        .map((response : Response) => {
            return response.json();
        })
       
    }

    private getWhitelabelFeatures(): Observable<any>{
        return this.http.get(environment.apiBaseUrl +'/api/whitelabelFeature' )
        .map((response : Response) => {
            return response.json();
        })
       
    }

    getWhitelabelByUrl(): Observable<any> {
        return this.http.get(environment.apiBaseUrl+'/api/whitelabel/by-url/'+  window.location.host)
        .map((response : Response) => {
            return response.json();
        })
        
    }

    getWhitelabelByProductId(productId): Observable<any> {
        return this
            .http
            .get(environment.apiBaseUrl+ "/api/whitelabel/by-productId/" + productId)
            .map((response : Response) => {
                return response.json();
            })


    }

    public getSettingByFeatureName(featureName: string): string{
        var config =  _.find(this.whitelabelConfigs, i=>{
            if(i.whitelabelFeature.featureName == featureName){
                return i;
            }
        }) as any;
        // if(!config){
        //     return _.find(this.whitelabelFeatures,{featureName: featureName}).defaultSettings;
        // }
        // if(!config.featureSettings){
        //     return config.whitelabelFeature.defaultSettings;
        // }else{
        //     return config.featureSettings;
        // }
        if(!config || !config.featureSettings){
            return null;
        }
        return config.featureSettings;
    }

    checkProductSSOTelemed(productId: number): Observable<any>{
        return this.http.get(this._baseUrl + `api/whitelabelConfig/check-ssotelemed/${productId}`)
            .map((res: Response) => {
                return res.json();
            });
    }
 
}




// WEBPACK FOOTER //
// ./src/app/_services/whitelabel.service.ts